import { render, staticRenderFns } from "./Somos1ReportsMaintenance.vue?vue&type=template&id=47cb186b&scoped=true"
import script from "./Somos1ReportsMaintenance.vue?vue&type=script&lang=js"
export * from "./Somos1ReportsMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb186b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47cb186b')) {
      api.createRecord('47cb186b', component.options)
    } else {
      api.reload('47cb186b', component.options)
    }
    module.hot.accept("./Somos1ReportsMaintenance.vue?vue&type=template&id=47cb186b&scoped=true", function () {
      api.rerender('47cb186b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1/Somos1ReportsMaintenance.vue"
export default component.exports